import React, { Component } from "react";

class Profile extends Component {
  constructor() {
    super();
  }
  render() {
    return (
      <div>
            <div id='profileName'>Poke Profile</div>
 <div className='mainProfile'>
       {this.props.profileLoaded ? (

          <div className='profileInfo'>

          <a><h2>Name:</h2>{this.props.profile.name.toUpperCase()}</a>
          <a><h2>Weight:</h2>{this.props.profile.weight}</a>
          <a><h2>Abilities:</h2>{this.props.profile.abilities.map(item => {
            return ( <a>{item.ability.name.toUpperCase()} <br/></a>)
          })}</a>
          <img src={this.props.profile.sprites.front_default}/>

        </div>


        ):(

        <div className='sentence'>PICK A POKEMON<br/> FROM THE LIST!</div>

        )}
      </div>
      </div>


    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/Profile.js